<template>
  <div class="bg-local bg-no-repeat bg-cover" style="background-image: url(/images/bg/navbarbg.png)">
    <div class="flex relative flex-col self-stretch pb-20 w-full min-h-[748px] shadow-[0px_4px_4px_rgba(0,0,0,0.25)] max-md:max-w-full ">
      <!-- 下面是头部区-->
      <TopBar theme="dark"></TopBar>
      <!-- 下面是首页显示区-->
      <div
        class="relative text-left text-w self-start mt-56 mb-20 ml-20 z-20 text-6xl font-semibold text-white max-lg:my-28 max-lg:max-w-full max-lg:text-4xl">
        生物识别解决方案<br />人机交互解决方案<br />智能IoT解决方案
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue';
export default {
  name: 'HomeTopBar',
  components: {
    TopBar,
  }
};
</script>